<div class="conteneur" *ngIf="children; else loader">
  <div class="fx-direction-row fx-wrap">
    <mat-card appearance="raised" *ngFor="let child of children" class="card">
      <mat-card-header class="card-header fx-direction-row fx-between-center">
        <mat-card-title class="fx-direction-row fx-start-center">
          <span>{{ child.prenom }} {{ child.nom }}</span>
        </mat-card-title>
        <button mat-mini-fab color="primary" [matMenuTriggerFor]="menu">
          <mat-icon>more_vert</mat-icon>
        </button>
      </mat-card-header>
      <mat-menu class="mat-menu-child" #menu="matMenu" xPosition="before">

        <button *ngFor="let formPart of formParts" mat-menu-item (click)="openForm(child.id, formPart.stepName)">
          <mat-icon color="primary">{{ readOnly ? 'visibility' : 'edit' }}</mat-icon>
          {{ formPart.label }}
        </button>

        <button mat-menu-item *ngIf="permToAddPhoto" (click)="openDialog(child)">
          <mat-icon color="primary">{{ readOnly ? 'visibility' : 'edit' }}</mat-icon>
          Photographie
        </button>

      </mat-menu>
      <mat-card-content class="card-content">
        <div class="content-grid">
          <div class="photo-section">
            <div *ngIf="permToAddPhoto && child.photo" class="container-img" matTooltip="Modifier la photo"
              (click)="openDialog(child)">
              <img [src]="child.photo" class="photo-viewer">
              <div class="edit-photo">
                <mat-icon class="icon-edit-photo" color="primary">edit</mat-icon>
              </div>
            </div>
            <div *ngIf="permToAddPhoto && !child.photo" class="no-photo-container" matTooltip="Ajouter une photo"
              (click)="openDialog(child)">
              <mat-icon class="icon-no-photo" color="accent">face</mat-icon>
              <div class="add-photo">
                <mat-icon class="icon-add-photo" color="primary">add</mat-icon>
              </div>
            </div>
          </div>
          <div class="info-grid">
            @if(child.dateNaissance){
            <div class="info-item">
              <span class="info-label">Date de naissance</span>
              <span class="info-value">{{ child.dateNaissance|date:'shortDate' }}</span>
            </div>
            }

            @if (child.age) {
            <div class="info-item">
              <span class="info-label">Age</span>
              <span class="info-value">{{ child.age.years }} {{ child.age.years > 1 ?
                'ans' : 'an' }}
                {{ child.age.months ? 'et ' + child.age.months + ' mois' : '' }}</span>
            </div>
            }

            @if (child.lieuNaissance) {
            <div class="info-item full-width">
              <span class="info-label">Lieu de naissance</span>
              <span class="info-value">{{ child.lieuNaissance }}
                ({{ child.depNaissance }})</span>
            </div>
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <ng-container [ngTemplateOutlet]="addCard"></ng-container>
  </div>

  <div *ngIf="!children.length && !permToCreate">
    <h2 style="text-align: center;">{{ 'enfant.empty_list'|trans }}</h2>
  </div>
</div>

<ng-template #loader>
  <app-loader [message]="'enfant.loading_data'|trans" class="margin"></app-loader>
</ng-template>

<ng-template #addCard>
  <mat-card appearance="outlined" *ngIf="permToCreate" class="card card-add">
    <mat-card-header class="fx-direction-row fx-center-center">
      <mat-card-title class="fx-direction-row fx-center-center">
        {{ 'enfant.add'|trans }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content style="flex:1; padding:16px" class="fx-direction-row fx-center-center">
      <button mat-fab color="primary" [disabled]="!addBtnUrl" [matTooltip]="'enfant.add'|trans"
        [routerLink]="addBtnUrl">
        <mat-icon>add</mat-icon>
      </button>
    </mat-card-content>
  </mat-card>
</ng-template>
